import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from "@angular/core";
import { Bot } from "../../../../../../../models/bot";
import { MappingBoard } from "../../../../../../../models/mapping-board";

@Component({
  selector: "mapping-checker",
  templateUrl: "./mapping-checker.component.html",
})
export class MappingCheckerComponent {

  @Input() public bot: Bot;
  @Input() public mappingBoard: MappingBoard;

  public linesOk: boolean = true;
  public isClosed: boolean = true;

  @Output() public showLines = new EventEmitter();
  @Output() public hideLines = new EventEmitter();
  @Output() public updateMapping = new EventEmitter();

  public ghosts: any[] = [];

  public clear() {
    this.ghosts = [...this.mappingBoard.ghostLines];
    this.mappingBoard.ghostLines.forEach((g) => {
      this.bot.inputFieldsMapping = this.bot.inputFieldsMapping.filter((ifm) => ifm.id !== g.lineId);
      this.mappingBoard.ghostLines = this.mappingBoard.ghostLines.filter((ifm) => ifm.lineId !== g.lineId);
    });
    this.updateMapping.emit({board: this.mappingBoard, bot: this.bot, ghosts: this.ghosts});

  }

  public openDrawer(e) {
    this.isClosed = false;
    this.askForHidingLines(e);
  }

  public closeDrawer(e) {
    this.isClosed = true;
    this.askForShowingLines(e);
  }

  public askForShowingLines(e) {
    this.showLines.emit(e);
  }

  public askForHidingLines(e) {
    this.hideLines.emit(e);
  }

}
